module.exports = __webpack_public_path__ + "img/Real-time-data.9eaba6c9.png";